export default {"src":"/_next/static/media/Ohio.2f3fcc8b.svg","height":665,"width":800,"blurWidth":0,"blurHeight":0};